import { apiRequest } from './client';
import type { IntegrationSummary, OuraDetailPayload } from './types';

export async function getOuraDetail(): Promise<IntegrationSummary<OuraDetailPayload>> {
  return apiRequest<IntegrationSummary<OuraDetailPayload>>('/integrations/oura/detail');
}
